module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00005-7790d9e61c38fa01e6cc9cbaaedaf47b.jpg";